<template>
  <div class="app-container">
    <el-card>
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <div class="flexs mb20 font14 c-8F8E8E" v-if="!activeType">
        <span>获取总佣金：{{financeStatic.sumCommissionMoney}}元</span>
        <span class="ml20">实际获得总金额：{{financeStatic.sumCommissionMoneyIn}}元</span>
        <span class="ml20">预计获得总金额：{{financeStatic.sumCommissionMoneyEstimate}}元</span>
        <span class="ml20">目前账户剩余佣金：{{financeStatic.commissionMoney}}元</span>
        <span class="ml20">已提现金额：{{financeStatic.withdrawalAmount}}元</span>
      </div>
      <el-table v-loading="listLoading" :data="list" class="mt20">
        <el-table-column label="收支类型" prop="" align="center" fixed>
          <template slot-scope="{row}">
            <div v-if="!activeType">{{row.commissionSource | setStatue}}</div>
            <!-- <div v-if="activeType">{{row.useType | setType}}</div> -->
            <div v-if="activeType">{{row.type?'收入':'支出'}}</div>
          </template>
        </el-table-column>
        <el-table-column label="金额变动" prop="money" align="center" fixed />
        <el-table-column label="当前金额" prop="walletMoney" align="center" />
        <!-- <template slot-scope="{row}">
            <span v-if="!activeType">{{row.userWalletPO.commissionMoney}}</span>
            <span v-if="activeType === 1">{{row.userWalletPO.balance}}</span>
            <span v-if="activeType === 2">{{row.userWalletPO.xiaoduMoney}}</span>
            <span v-if="activeType === 3">{{row.userWalletPO.tuition}}</span>
            <span v-if="activeType === 4">{{row.userWalletPO.integral}}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="来源" prop="source" align="center" v-if="activeType" />
        <el-table-column label="订单编号" prop="orderNum" align="center" />
        <el-table-column label="提现手续费" prop="serviceCharge" align="center" v-if="!activeType" />
        <el-table-column label="变动时间" prop="operatedTime" sortable align="center">
          <template slot-scope="{row}">
            {{row.createdTime || row.operatedTime}}
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="operatedTime" sortable align="center" v-if="!activeType">
          <template slot-scope="{row}">
            {{(row.commissionSource==5 || row.commissionSource==6)?'已扣减':(row.state === 1?'待入账':(row.state === 2?'已入账':(row.state === 3?'已取消入账':'')))}}
          </template>
        </el-table-column>
        <el-table-column label="出入账"  align="center" v-if="activeType">
          <template slot-scope="{row}" v-if="row.realNameReceive">
            {{row.realNameReceive}}<span>({{row.levelNameReceive}})</span>{{row.mobileReceive}}
          </template>
        </el-table-column>
        <el-table-column label="操作人" prop="commissionMoney" align="center" v-if="activeType">
          <template slot-scope="{row}" v-if="row.userInfo">
            {{row.userInfo.userName}}<span v-if="row.sysRoleList && row.sysRoleList.length">({{row.sysRoleList[0].roleName}})</span>{{row.userInfo.userPho}}
          </template>
        </el-table-column>
        <el-table-column label="城市类型" prop="isOtherCity" align="center">
          <template slot-scope="{row}">
            <span v-if="row.isOtherCity&&row.isOtherCity>0">
              {{ row.isOtherCity===1?'跨城市':row.isOtherCity===2?"同城市":"-" }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="银行名称" prop="bankName" align="center">
          <template slot-scope="{row}">
            {{ row.bankNum || row.bankName || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark" align="center" width="200">
          <template slot-scope="{row}">
            <div v-if="row.remark">
              <span v-if="row.remark.length <= 30">{{row.remark}}</span>
              <span v-else>
                {{row.remark.substring(0, 30)}}...
                <el-button type="text" @click="showRemarkDetail(row.remark)" class="remark-more-btn">查看更多</el-button>
              </span>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" v-if="activeType">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleEdit(row)" v-if="isEditable(row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
      <el-dialog title="编辑" :visible.sync="editVisible" width="600px" :close-on-click-modal="false">
        <el-form ref="editFormRef" :model="editForm" :rules="editRules" label-width="80px" size="small">
          <el-form-item label="原因" prop="useCode">
            <el-select v-model="editForm.useCode" filterable placeholder="请选择">
              <el-option :label="item.configName" :value="item.configKey" v-for="(item,index) in reasonOptions" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="金额" prop="money">
            <el-input v-model="editForm.money" placeholder="请输入金额" />
          </el-form-item>
          <!-- <el-form-item label="选银行" prop="isSelectBank">
            <el-radio-group v-model="editForm.isSelectBank" @change="handleEditBankSelectChange">
              <el-radio :label="false">否</el-radio>
              <el-radio :label="true">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="银行" prop="bankName" v-if="editForm.isSelectBank">
            <div style="display: flex; align-items: center;">
              <el-select v-model="editForm.bankName" placeholder="请选择银行" filterable clearable style="flex: 1;">
                <el-option :label="item.bankName" :value="item.bankName" v-for="(item, index) in visibleBankList" :key="index"></el-option>
              </el-select>
              <el-button type="text" @click="toggleBankFilter" style="margin-left: 10px;">
                {{ showAllBanks ? '按城市过滤' : '显示全部' }}
              </el-button>
            </div>
          </el-form-item> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editVisible=false">取消</el-button>
          <el-button type="primary" :loading="editLoading" @click="submitEdit">保存</el-button>
        </div>
      </el-dialog>
      
      <!-- 备注详情弹窗 -->
      <el-dialog title="备注详情" :visible.sync="remarkDetailVisible" width="800px" :close-on-click-modal="false" class="remark-detail-dialog">
        <div class="remark-content">
          <div class="remark-text">{{remarkDetailText}}</div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="remarkDetailVisible=false">关闭</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import managecustomerwalletApi from '@/api/cust/managecustomerwallet'
import sysGiftAccountReasonApi from '@/api/config/sysGiftAccountReason'
import sysDataconstantApi from '@/api/config/sysDataconstant'
export default {
  props: ['rowItem', 'activeType'],
  data() {
    return {
      list: [],
      formVisible: false,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
      financeStatic: {},
      reasonOptions: [],
      editVisible: false,
      editLoading: false,
      editForm: {
        id: null,
        useCode: null,
        money: null,
        isSelectBank: false,
        bankName: null,
      },
      editRules: {
        useCode: [{ required: true, message: '请选择原因', trigger: 'change' }],
        money: [
          { required: true, message: '请输入金额', trigger: 'blur' },
          { pattern: /^(?!0(\.0+)?$)(\d+(\.\d+)?|\.\d+)$/, message: '请输入正确的金额', trigger: 'blur' }
        ],
        bankName: [
          {
            validator: (rule, value, callback) => {
              if (this.editForm.isSelectBank && !value) {
                callback(new Error('请选择银行'))
                return
              }
              callback()
            },
            trigger: 'change'
          }
        ]
      },
      remarkDetailVisible: false,
      remarkDetailText: '',
      bankList: [],
      showAllBanks: false,
      currentEditRow: null
    }
  },
  computed: {
    filteredBankList() {
      const enabled = (this.bankList || []).filter(it => String(it.isEnable) === '1')
      const selectedCityCompanyId = this.getCurrentCityCompanyId()
      if (selectedCityCompanyId !== undefined && selectedCityCompanyId !== null && selectedCityCompanyId !== '') {
        const ccIdNum = Number(selectedCityCompanyId)
        return enabled.filter(it => Number(it.cityCompanyId || it.cityId) === ccIdNum)
      }
      return enabled
    },
    visibleBankList() {
      const enabled = (this.bankList || []).filter(it => String(it.isEnable) === '1')
      return this.showAllBanks ? enabled : this.filteredBankList
    }
  },
  filters: {
    setStatue(val) {
      switch (val) {
        case 1:
          return "订货";
        case 2:
          return "秒杀";
        case 3:
          return "充值";
        case 4:
          return "学费";
        case 5:
          return "提现";
        case 6:
          return "管理后台扣减";
        case 7:
          return "课程";
        case 8:
          return "会议";
        case 9:
          return "线下凭证升级";
        default:
          return val;
      }
    },
    setType(val) {
      switch (val) {
        case 1:
          return "下单使用";
        case 2:
          return "下单使用";
        case 3:
          return "充值";
        case 4:
          return "下单使用";
        case 5:
          return "学费赠送";
        case 6:
          return "后台赠送";
        case 7:
          return "后台扣除";
        case 8:
          return "线下会议报名赠送";
        default:
          return val;
      }
    }
  },
  created() {
    this.handleShow()
    this.getFinanceCommissionStatic()
    this.getReasonOption()
    this.getBankList()
    // this.getMeeting()
    // if (this.rowItem.areaCount) this.changeIdentity()
    // if (this.technicalState) this.getShareData()
  },
  methods: {
    toggleBankFilter() {
      this.showAllBanks = !this.showAllBanks
    },
    getBankList() {
      sysDataconstantApi.fetchBatchCode({ code: 'lineUpMoneyBankType' }).then(({ data }) => {
        this.bankList = data.list[0].content ? JSON.parse(data.list[0].content) : []
      })
    },
    getCurrentCityCompanyId() {
      if (this.currentEditRow) {
        return this.currentEditRow.cityCompanyId || this.currentEditRow.customerCityCompanyId || this.currentEditRow.cityId
      }
      return this.rowItem && (this.rowItem.cityCompanyId || this.rowItem.cityId)
    },
    handleEditBankSelectChange(val) {
      if (!val) {
        this.editForm.bankName = null
      }
      this.$nextTick(() => {
        this.$refs.editFormRef && this.$refs.editFormRef.clearValidate('bankName')
      })
    },
    isEditable(row) {
      if (!this.activeType) return false
      if (!row || row.useCode === undefined || row.useCode === null) return false
      return (this.reasonOptions || []).some(it => it && it.configKey == row.useCode)
    },
    getReasonOption() {
      sysGiftAccountReasonApi.fetchList({ allowEdit: 1 }).then(({ data }) => {
        if (data) { this.reasonOptions = data.list || [] }
      })
    },
    getFinanceCommissionStatic() {
      managecustomerwalletApi.findManageFinanceCommissionStatic({ userId: this.rowItem.userId, userWalletId: this.rowItem.userWalletId }).then(res => {
        this.financeStatic = res.data
      })
    },
    handleShow() {
      // console.log('activeType: ', this.activeType, this.rowId);
      this.doQueryList({
        pageNo: 1
      })
    },
    async doQueryList({
      pageNo,
      pageSize
    }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      let query = {
        ...this.query
      }
      query.userWalletId = this.rowItem.userWalletId
      if (this.rowItem.queryStartTime) query.startTime = this.rowItem.queryStartTime
      if (this.rowItem.queryEndTime) query.endTime = this.rowItem.queryEndTime
      if (this.activeType) {
        query.moneyType = this.activeType
        managecustomerwalletApi.fetchListDetailPage(query).then(({
          data
        }) => {
          this.list = data.list
          this.total = data.total
        })
      } else {
        managecustomerwalletApi.fetchDetailList(query).then(({
          data
        }) => {
          // console.log('data222: ', data);
          this.list = data.list
          this.total = data.total
        })
      }
    },
    showArea() {
      this.formVisible = true
    },
    // 获取客户数量
    async getClientNum() {
      const {
        data
      } = await clientListApi.getCountByLevelGroup({
        technicianId: this.info.id
      })
      // console.log('客户数量data: ',data);
      if (data.length) {
        data.forEach(item => {
          this.statisticsList.map(i => {
            if (i.key == item.id) i.value = item.count
            return i
          })
        })
        // console.log('this.statisticsList: ',this.statisticsList);
      }
    },
    // 获取团队数量
    async getChildNum() {
      const {
        data
      } = await technicianInfoApi.getChildCount(this.info.id)
      // console.log('data: ',data);
      this.statisticsList[0].value = data
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    },
    handleEdit(row) {
      this.currentEditRow = { ...row }
      this.editForm = {
        id: row.detailId || null,
        useCode:  null,
        money: row.money != null ? Math.abs(row.money) : null,
        isSelectBank: !!row.bankName,
        bankName: row.bankName || null
      }
      this.showAllBanks = false
      this.editVisible = true
    },
    submitEdit() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return
        try {
          this.editLoading = true
          // 约定后端接口：更新钱包明细原因与金额
          const params = {
            detailId: this.editForm.id,
            useCode: this.editForm.useCode,
            money: this.editForm.money,
            bankNum: null,
            isOtherCity: 0
          }
          if (this.editForm.isSelectBank) {
            params.bankNum = this.editForm.bankName
            const selectedCityCompanyId = this.getCurrentCityCompanyId()
            const selectedBank = (this.bankList || []).find(it => it.bankName === this.editForm.bankName)
            if (selectedCityCompanyId !== undefined && selectedCityCompanyId !== null && selectedCityCompanyId !== '' && selectedBank) {
              const bankCityId = Number(selectedBank.cityCompanyId || selectedBank.cityId)
              const customerCityId = Number(selectedCityCompanyId)
              params.isOtherCity = (bankCityId === customerCityId) ? 2 : 1
            } else {
              params.isOtherCity = 1
            }
          }
          await managecustomerwalletApi.updateWalletDetail(params)
          this.$message.success('保存成功')
          this.editVisible = false
          this.doQueryList({ pageNo: this.query.pageNo })
        } catch (e) {
          this.$message.error('保存失败')
        } finally {
          this.editLoading = false
        }
      })
    },
    showRemarkDetail(remark) {
      this.remarkDetailText = this.formatRemarkText(remark)
      this.remarkDetailVisible = true
    },
    formatRemarkText(remark) {
      if (!remark) return ''
      
      // 处理包含时间戳和修改记录的备注
      let formattedText = remark
      
      // 按时间戳分割并格式化
      const timestampRegex = /\[(\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2})/g
      const parts = formattedText.split(timestampRegex)
      
      if (parts.length > 1) {
        let result = ''
        for (let i = 0; i < parts.length; i++) {
          if (i % 2 === 0) {
            // 非时间戳部分
            if (parts[i].trim()) {
              result += parts[i].trim()
            }
          } else {
            // 时间戳部分
            if (i + 1 < parts.length) {
              const timestamp = parts[i]
              const content = parts[i + 1]
              result += `\n[${timestamp}${content}]`
            }
          }
        }
        formattedText = result
      }
      
      // 进一步格式化修改记录
      formattedText = formattedText
        .replace(/金额修改:([^->]+)->([^\[\]]+)/g, '金额修改: $1 → $2')
        .replace(/入账原因编码修改:([^->]+)->([^\[\]]+)/g, '入账原因编码修改: $1 → $2')
        .replace(/入账原因修改:([^->]+)->([^\[\]]+)/g, '入账原因修改: $1 → $2')
        .replace(/\]\[/g, ']\n[')
        .replace(/\]\s*\[/g, ']\n[')
      
      return formattedText.trim()
    }
  }

}
</script>

<style lang="scss" scoped>
.sex-box {
  border-radius: 50%;
  border: 1px solid;
  width: 16px;
  height: 16px;
  margin: 0 4px;
}

.label-box {
  background: #1596cd1a;
  padding: 2px;
  border-radius: 2px;
  color: #1596cd;
}

.grid-content {
  background: #60b7dc33;
  padding: 20px 30px 30px;
  border-radius: 20px;
  font-size: 20px;
  width: 350px;
  height: 153px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
::v-deep .el-select{
  width: 100%;
}

/* 备注相关样式 */
.remark-more-btn {
  color: #409EFF !important;
  font-size: 12px;
  padding: 0 4px !important;
  margin-left: 4px;
}

.remark-more-btn:hover {
  color: #66b1ff !important;
}

/* 备注详情弹窗样式 */
::v-deep .remark-detail-dialog {
  .el-dialog {
    border-radius: 8px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  }
  
  .el-dialog__header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 20px 20px 15px;
    border-radius: 8px 8px 0 0;
    
    .el-dialog__title {
      font-size: 16px;
      font-weight: 600;
    }
    
    .el-dialog__close {
      color: white;
      font-size: 18px;
    }
    
    .el-dialog__close:hover {
      color: #f0f0f0;
    }
  }
  
  .el-dialog__body {
    padding: 25px 20px;
  }
  
  .el-dialog__footer {
    padding: 15px 20px 20px;
    text-align: center;
    border-top: 1px solid #f0f0f0;
  }
}

.remark-content {
  .remark-text {
    font-size: 14px;
    line-height: 1.8;
    color: #333;
    word-break: break-all;
    white-space: pre-wrap;
    min-height: 100px;
    max-height: 400px;
    overflow-y: auto;
    padding: 15px 0;
    background: transparent !important;
    border: none !important;
    
    &::-webkit-scrollbar {
      width: 6px;
    }
    
    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb:hover {
      background: #a8a8a8;
    }
  }
}
</style>
